module.exports = __webpack_public_path__ + "img/Hilton_Wien_717x350.jpg";